











































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Ajv from "ajv";
import { TrialKey } from "../../schema/Schema.js";

export type VForm = Vue & {
  validate: () => boolean;
  resetValidation: () => boolean;
  reset: () => void;
};

export interface Errors {
  company: string[];
  email: string[];
  domains: string[];
  repository: string[];
}

const ajv = new Ajv({ allErrors: true, jsonPointers: true });
const validate = ajv.compile(TrialKey);

@Component({})
export default class Home extends Vue {
  model = {
    valid: true,
    company: "",
    email: "",
    domains: ["localhost:8080", "localhost:4200"],
    repository: "",
    licenseKey: "",
  };
  rules = {
    single: [(value: string) => !!value || "This field is required."],
    multi: [(value: string[]) => !!value.length || "This field is required"],
  };
  snackbar = {
    visible: false,
    color: "",
    icon: "",
    message: "",
  };
  $refs!: {
    license: HTMLFormElement;
    form: VForm;
  };
  errors: Errors = {
    company: [],
    email: [],
    domains: [],
    repository: [],
  };
  delimeters = [" ", ","];
  validUntil = "";

  created() {
    const modelJSON = localStorage.getItem("model");
    if (modelJSON) {
      this.model = JSON.parse(modelJSON);
    }
    const validUntil = localStorage.getItem("validUntil");
    if (validUntil) this.validUntil = validUntil;
  }

  @Watch("model", { deep: true })
  onModelChange(value: string, oldValue: string) {
    localStorage.setItem("model", JSON.stringify(value));
  }

  resetErrors(which: "company" | "email" | "domains" | "repository" | undefined = undefined) {
    switch (which) {
      case undefined:
        this.errors = {
          company: [],
          email: [],
          domains: [],
          repository: [],
        };
        break;
      case "company":
        this.errors.company = [];
        break;
      case "email":
        this.errors.email = [];
        break;
      case "domains":
        this.errors.domains = [];
        break;
      case "repository":
        this.errors.repository = [];
        break;
    }
  }

  validate() {
    this.resetErrors();
    const valid = validate(this.model);
    if (valid) return true;
    if (validate.errors)
      for (const error of validate.errors) {
        if (!error || !error.message) continue;
        switch (error.dataPath) {
          case "/company":
            if (!this.errors.company.includes(error.message)) this.errors.company.push(error.message);
            break;
          case "/email":
            if (!this.errors.email.includes(error.message)) this.errors.email.push(error.message);
            break;
          case "/domains":
            if (!this.errors.domains.includes(error.message)) this.errors.domains.push(error.message);
            break;
          case "/repository":
            if (!this.errors.repository.includes(error.message)) this.errors.repository.push(error.message);
            break;
        }
      }
    return false;
  }

  generate() {
    if (!this.validate()) return;
    void fetch("/api/free-key", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company: this.model.company,
        email: this.model.email,
        domains: this.model.domains,
        repository: this.model.repository,
      }),
    })
      .then((res) => {
        if (res.status !== 200) {
          this.snackbar = {
            message: "Could not connect to license services.",
            icon: "mdi mdi-alert-circle",
            color: "error",
            visible: true,
          };
        }
        return res.json();
      })
      .then((data) => {
        if (data.ok) {
          this.model.licenseKey = data.license.license.key.replace(/\n/gi, "\\n");
          const validUntil = new Date(data.license.validUntil).toLocaleString();
          this.validUntil = validUntil;
          localStorage.setItem("validUntil", validUntil);
          setTimeout(() => {
            this.copy();
          }, 100);
        } else {
          this.snackbar.message = data.message;
          this.snackbar.icon = "mdi mdi-alert-circle";
          this.snackbar.color = "warning";
          this.snackbar.visible = true;
        }
      });
  }

  copy() {
    if (!this.model.licenseKey) {
      return (this.snackbar = {
        message: "Try to generate it first.",
        icon: "mdi mdi-help-circle",
        color: "warning",
        visible: true,
      });
    }
    const textToCopy = this.$refs.license.$el.querySelector("input");
    textToCopy.select();
    document.execCommand("copy");
    this.snackbar = {
      message: "The license key has been copied to the clipboard.",
      icon: "mdi mdi-content-copy",
      color: "success",
      visible: true,
    };
  }
}
